export default "__VITE_ASSET__7bd0e755__"